import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getLeaderById } from "../../store/actions/user.action";
import Loader from "../../components/Loader/Loader";
import LeaderProfileRegular from "./LeaderProfileRegular";
import LeaderProfileFUHSD from "./LeaderProfileFUHSD";

function RequestMeeting(props) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const currentLeader = useSelector((state) => state.user.currentLeader);

  useEffect(() => {
    dispatch(getLeaderById({ token, id }));
  }, [dispatch, token, id]);

  // Show loader while fetching leader data
  if (!currentLeader) {
    return (
      <div className="max-w-screen-2xl mx-auto p-4 xl:p-0">
        <div className="min-h-96 flex items-center justify-center border-t border-blue-gray-50 p-4">
          <Loader />
        </div>
      </div>
    );
  }

  // Check affiliation and render appropriate component
  const affiliation = currentLeader?.owner?.affiliation;

  if (affiliation === "FUHSD") {
    return <LeaderProfileFUHSD />;
  }

  return <LeaderProfileRegular />;
}

export default RequestMeeting;
